define('languages/en_US',[],function () {
  'use strict';
  return {
    //MENU
    'menu.home': 'Home',
    'menu.overview': 'Overview',
    'menu.my_media': 'My media',
    'menu.my_ads': 'My ads',
    'menu.settings': 'Settings',
    'menu.help': 'Help',
    'menu.logout': 'Logout',

    //PAGE TITLES
    'page_titles.home': 'Home',
    'page_titles.news': 'News',
    'page_titles.edit_news_item': 'Edit news item',
    'page_titles.overview': 'Overview',
    'page_titles.content': 'Content',
    'page_titles.my_media': 'My media',
    'page_titles.my_ads': 'My ads',
    'page_titles.select_template': 'Select template',
    'page_titles.edit_ad': 'Edit ad',
    'page_titles.settings': 'Settings',
    'page_titles.help': 'Help',
    'page_titles.logout': 'Logout',

    //HEADER
    'header.app_name': 'ICA Handlarapp',
    'header.menu': 'Menu',
    'header.overview': 'Overview',
    'header.select_store_modal.switch_store': 'Switch store?',
    'header.select_store_modal.select_store': 'Select store',
    'header.select_store_modal.switch': 'Switch',

    //LOGIN
    'login.label.username': 'Username',
    'login.label.password': 'Password',
    'login.placeholder.username': 'firstname.lastname@email.domain',
    'login.placeholder.password': '●●●●●',
    'login.button.login': 'Login',
    'login.text.forgot_password': 'Lost your password?',
    'login.text.login_error': 'Something went wrong, please check your username and password and try again.',

    //CHANGE PASSWORD
    'change_password.header.change_password': 'Change password',
    'change_password.label.old_password': 'Old password',
    'change_password.label.new_password': 'New password',
    'change_password.button.send': 'Send',
    'change_password.error': 'You have to enter your old and new password',
    'change_password.success': 'Your password has been changed',

    //HOME
    'home.link.edit_news': 'Edit news',

    //NEWS
    'news.label.header': 'Header',
    'news.label.date': 'Date (if you enter a future date, the news will not be displayed prior to this date)',
    'news.label.end_date': 'End date (if you enter a date here the news item will not be showed after this date)',
    'news.label.text': 'Text',
    'news.button.add_news_item': 'Add news item',
    'news.button.save': 'Save',
    'news.button.edit': 'Edit',
    'news.button.remove': 'Delete',
    'news.button.remove.confirm': 'Delete?',

    //NEWSFORM
    'newsform.button.save': 'Save news item',

    //OVERVIEW
    'overview.intro.heading': '',
    'overview.intro.text': '',
    'screens.header.image': 'Image',
    'screens.header.title': 'Name',
    'screens.header.zone': 'Zone',
    'screens.header.tags': 'Tags',
    'screens.header.preview_loop': 'Preview loop',
    'screens.button.map_view': 'Map',
    'screens.button.list_view': 'View',

    //SCREEN
    'screen.button.central_content': 'Central content',
    'screen.button.local_content': 'Local content',
    'screen.header.media': 'Media',
    'screen.header.name': 'Name',
    'screen.header.start_date': 'Start',
    'screen.header.end_date': 'End',
    'screen.header.edit': 'Edit',
    'screen.header.like': 'Like',
    'screen.header.delete': 'Delete',
    'screen.header.disconnect': 'Disconnect',
    'screen.button.add_existing_ad': 'Select existing ad',
    'screen.button.create_new_ad': 'Create new ad',
    'screen.button.edit': 'Edit',
    'screen.button.remove': 'Remove',
    'screen.button.remove.confirm': 'OK?',
    'screen.link.download_media': 'Right click and select "Save as" to download the movie.',

    //MY MEDIA
    'file.button.add_media': 'Upload new files',
    'file.header.media': 'Media',
    'file.header.name': 'Name',
    'file.header.format': 'Format',
    'file.header.length': 'Length',
    'file.header.date_added': 'Date added',
    'file.header.delete': 'Delete',
    'file.button.remove': 'Delete',
    'file.button.remove.confirm': 'Delete?',

    //TEMPLATES
    'htmlad_template.header.thumbnail': 'Media',
    'htmlad_template.header.title': 'Name',
    'htmlad_template.header.profile': 'Profile',
    'htmlad_template.header.category': 'Category',
    'htmlad_template.header.format': 'Format',
    'htmlad_template.header.date_added': 'Date added',

    'ad_form_template.infotext': 'If you use this template with product barcodes (EAN) it will populate the template from a Kesko source with available product information. Some information will be locked from editing, others can be edited. All product information will be connected to the Kesko source for updates so if you edit connected information it will be disconnected from updates.',
    'ad_form_template.connected_infotext': 'Connected to source',
    'ad_form_template.will_disconnect_infotext': 'Will disconnect from source',
    'ad_form_template.disconnected_infotext': 'Disconnected from source',
    'ad_form_template.connected_box_text': 'Connected',
    'ad_form_template.will_disconnect_box_text': 'Connected',
    'ad_form_template.disconnected_box_text': 'Disconnected',

    //MY ADS
    'my_ads.button.create_new': 'Create new ad',
    'my_ads.button.back': 'Back',
    'my_ads.header.image': 'Image',
    'my_ads.header.name': 'Name',
    'my_ads.header.start_date': 'Start date',
    'my_ads.header.end_date': 'End date',
    'my_ads.header.edit': 'Edit',
    'my_ads.header.zones': 'Zones',
    'my_ads.header.delete': 'Delete',
    'my_ads.button.edit': 'Edit',
    'my_ads.button.remove': 'Remove',
    'my_ads.button.remove.confirm': 'Remove?',
    'my_ads.button.add': 'Add',

    //EXPORT ADS
    'export.header.image': 'Image',
    'export.header.name': 'Name',
    'export.header.download': 'Download',
    'export.link.download': 'Download',
    'export.text.render_in_progress': 'Render in progress',

    //VIEW OPTIONS
    'view_options.label.select_week': 'Select week',

    //SEARCH
    'search_field.placeholder': 'Search',
    'search_field.button.search': 'Search',

    //EDIT
    'edit.header.ad_name': 'Title',
    'edit.label.ad_name': 'Ad name',
    'edit.placeholder.ad_name': 'Ad name',
    'edit.button.edit': 'Edit',
    'edit.button.play': 'Play',
    'edit.button.pause': 'Pause',
    'edit.button.preview': 'Preview ad',
    'edit.button.schedule': 'Schedule',
    'edit.button.save': 'Save',
    'edit.button.copy_ad.disabled': 'You need to save the ad before you can copy it',
    'edit.button.copy_ad': 'Copy ad',

    //SCHEDULE
    'schedule.header.schedule': 'Schedule',
    'schedule.header.days': 'Weekday',
    'schedule.header.daypart': 'Daypart',
    'schedule.header.show_in_zones': 'Show in zone(s)',
    'schedule.placeholder.start_date': 'Start date',
    'schedule.placeholder.end_date': 'End date',
    'schedule.placeholder.start_time': 'Start time',
    'schedule.placeholder.end_time': 'End time',

    //MEDIA
    'media.search_form.placeholder.search_media': 'Search media',
    'media.search_form.button.search': 'Search',
    'media.button.central_media': 'Images',
    'media.button.movies': 'Movies',
    'media.button.local_media': 'Local',
    'media.header.media': 'Media',
    'media.header.name': 'Name',
    'media.link.close': 'Close',
    'media.link.select': 'Select',
    'media.link.delete': 'Delete',

    //SETTINGS
    'settingsform.button.save': 'Save',
    'settingsform.feedback.settings_saved': 'Settings saved',

    //MODALS
    'modal.link.close': 'Close',
    'modal.button.confirm': 'OK',
    'modal.button.cancel': 'Cancel',
    'modal.button.copy': 'Copy',
    'modal.button.delete': 'Delete',
    'modal.button.schedule': 'Schedule',

    'modal.header.delete': 'Are you sure you want to delete?',
    'modal.header.delete_media': 'Are you sure? If you delete media files that are used in advertisements, these may stop functioning.',

    'modal.header.add_to_homescreen': 'Add app to homescreen',
    'modal.text.add_to_homescreen': 'Click menu and "Add to homescreen"',

    'modal.header.ad_saved': 'Ad saved',
    'modal.text.ad_saved': 'Your ad is now saved',

    'modal.header.schedule_ad': 'The ad is saved but not yet scheduled',
    'modal.text.schedule_ad': 'You need to schedule your ad before it will be displayed',

    'modal.header.copy_ad': 'Copy ad',
    'modal.text.copy_ad': 'This will create a new ad with the same settings and scheduling.',

    'modal.header.logged_out': 'You have been logged out',
    'modal.text.logged_out': 'Your ad was not saved. Open a new tab and please log in again, then save your ad.',

    'modal.header.missing_fields': 'The ad was not saved.',
    'modal.text.missing_fields': 'Please check that you have entered data for all required fields',

    'modal.header.file_uploads': 'To consider when uploading media:',
    'modal.text.file_uploads_image': '<h3>Images:</h3>' +
      'The recommended image size for a portrait display is 1080 * 1920 pixels<br>' +
      'Recommended picture size for the landscape screen is 1920 * 1080 pixels<br>' +
      'Do not upload images less than 500 * 500 pixels<br>' +
      'Acceptable image formats: JPEG, PNG, PDF<br>' +
      'Maximum file size: 100 MB',

    'modal.text.file_uploads_video': '<h3>Videos:</h3>' +
      'The preferred video size for portrait display is 1080 * 1920 pixels<br>' +
      'The preferred video size for landscape screen is 1920 * 1080 pixels<br>' +
      'Accepted video formats: MP4, MOV<br>' +
      'Maximum file size: 100 MB<br>' +
      'The preferred video length: <30 sec',

    'modal.header.duplicate_name': 'Name taken',
    'modal.text.duplicate_name': 'There is already another ad with the same name, please rename your ad and try again.',

    'modal.header.map_zone_picker': 'Select zone on screen',
    'modal.text.map_zone_picker': 'This screen has several zones. Select which zone you want to look at.',

    //PREVIEW LOOP MODAL
    'previewmodal.header': 'View loop for screen ',
    'previewmodal.body': 'View the loop to see how central and local media play in zone ## at specific date and time based on scheduling, frequency, rules, over booking, fillers, loop length and communication mix.',
    'previewmodal.date': 'Date:',
    'previewmodal.time': 'Time:',
    'previewmodal.cancel': 'Cancel',
    'previewmodal.view_loop': 'View loop',
    'previewloop.nomedia': 'No data for the selected time period can be found, select a new time period.',
    
    //VIEW LOOP MODAL
    'viewloopmodal.titel.minutes_and_seconds': 'Loop on %{playerName} %{date} at %{time}. Total length %{minutes} minute(s) and %{seconds} second(s).',
    'viewloopmodal.titel.seconds': 'Loop on %{playerName} %{date} at %{time}. Total length %{seconds} second(s).',
    'viewloopmodal.titel': 'Loop on %{playerName} %{date} at %{time}.',
    'viewloopmodal.nomedia': 'No data for the selected time period can be found, select a new time period.',

    // PAGINATION
    'pagination.button.view_all': 'Show all',
    'pagination.button.view_pagination': 'Back',

    //DAYS
    'All days': 'All days',
    'Monday': 'Monday',
    'Tuesday': 'Tuesday',
    'Wednesday': 'Wednesday',
    'Thursday': 'Thursday',
    'Friday': 'Friday',
    'Saturday': 'Saturday',
    'Sunday': 'Sunday',

    //MISC
    'date_format': 'YYYY-MM-DD',
    'time_format': 'HH.mm',

    // FORM SECTION
    'form_section.buttons.add': 'Add',
    'form_section.title.empty': 'Empty'

  };
});

